<template>
    <input type="file" @change="readFile" @click="$event.target.value = ''" ref="excelUpload"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
</template>



<script setup>
import * as XLSX from 'xlsx';
import { reactive, ref } from 'vue'
import common from '@/js/common';

const excelUpload = ref()
const emits = defineEmits(['return'])

const props = defineProps({
    headerKeys: {
        type: Array,
        default: []
    },
    dataFormat: {
        type: Boolean,
        default: true
    }
})

const state = reactive({
    visibleHeadProps: null,
    instance: undefined,
})

const selectUploadFile = () => {
    excelUpload.value.click()
}

const resetUploadFile = () => {
    excelUpload.value.value = '';
}

const readFile = (event) => {
    let returnData = new Object()
    returnData.file = event.target.files[0];
    const file = event.target.files[0];

    let reader = new FileReader();
    let tmpResult = [];
    reader.onload = (e) => {
        let data = reader.result;
        let workBook = XLSX.read(data, { type: 'binary', cellDates: true });
        workBook.SheetNames.forEach(sheetName => {
            if (props.headerKeys.length > 0) {
                let asciiNum = 65
                for (let i = 0; i < props.headerKeys.length; i++) {
                    let capital = String.fromCharCode(asciiNum + i) + '1';

                    if (workBook.Sheets[sheetName][capital]?.w && workBook.Sheets[sheetName][capital]?.w != null && workBook.Sheets[sheetName][capital]?.w != undefined) {
                        workBook.Sheets[sheetName][capital].w = props.headerKeys[i]

                    }
                }
            }
            const roa = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
            tmpResult.push(roa)
        });
        //emit을 통하여 부모창에게 읽은 엑셀파일을 전달한다.
        returnData.sheets = tmpResult
        emits('return', returnData)
    };
    reader.readAsBinaryString(file);
}
const excelSheet2 = (fileName, header, dataList, header2, dataList2) => {
    const ws = excelDownload(header, dataList);
    let wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Yearly Cashflow FCST')
    let ws2;
    if (header2) {
        ws2 = excelDownload(header2, dataList2);
        XLSX.utils.book_append_sheet(wb, ws2, 'Yearly Cashflow 주차별')
        autofitColumns(ws2)
    }
    autofitColumns(ws)
    // grayBackGround(ws)
    const subject = dataList.find(item => item.subject)?.subject || '';
    headerDateInsert(ws,subject)
    XLSX.writeFile(wb, fileName + '.XLSX', { bookType: 'xlsx' })
}

const excelSheet3 = (fileName, header, dataList, header2, dataList2) => {
    const ws = excelDownload(header, dataList);
    let wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Yearly Cashflow FCST')
    let ws2;
    if (header2) {
        ws2 = excelDownload(header2, dataList2);
        XLSX.utils.book_append_sheet(wb, ws2, 'Yearly Cashflow 주차별')
        autofitColumns(ws2)
    }
    autofitColumns(ws)
    XLSX.writeFile(wb, fileName + '.XLSX', { bookType: 'xlsx' })
}

const excelDownload = (header, dataList) => {
    let options = {
        header: header,
        headProps: 'header'
    }
    // data row별 header에 바인딩 될 매핑값 설정 
    let headProps = []

    if (Array.isArray(options.headProps)) {
        headProps = options.headProps
    } else if (options.headProps === 'header') {
        for (let h of header) {
            headProps.push(h.field)
        }
    } else {
        headProps = Object.keys(dataList[0])
    }

    state.visibleHeadProps = headProps
    state.instance = document.createElement('table')

    // Header 세팅
    let headerSet = []

    if (!Array.isArray(header[0])) {
        headerSet.push(header)
    } else {
        headerSet = header
    }

    let thead = document.createElement('thead')

    for (let row of headerSet) {
        let tr = document.createElement('tr')

        for (let h of row) {
            let rowspan = h.rowspan || '1'
            let colspan = h.colspan || '1'
            let th = document.createElement('th')
            th.setAttribute('rowspan', rowspan)
            th.setAttribute('colspan', colspan)
            th.innerText = h.headerName ? h.headerName : h.header
            tr.appendChild(th)
        }

        thead.appendChild(tr)
    }

    state.instance.appendChild(thead)


    // Body 세팅
    let tbody = document.createElement('tbody')

    for (let row of dataList) {
        let tr = document.createElement('tr')
        for (let cellkey of state.visibleHeadProps) {
            let td = document.createElement('td')
            if (row[cellkey] == undefined) {
                td.innerText = ''
            } else {
                td.innerText = row[cellkey]
            }
            tr.appendChild(td)
        }

        tbody.appendChild(tr)
    }

    state.instance.appendChild(tbody)

    // instance에 만들어진 table을 엑셀파일로 저장
    let config = {
        raw: true,
        type: 'string'
    }
    // 스타일 설정
    const style = {
        font: {
            bold: true,
            color: { rgb: 'FF0000' } // 빨간색
        },
        fill: {
            type: 'pattern',
            patternType: 'solid',
            fgColor: { rgb: 'C0C0C0' } // 회색
        }
    };


    let ws = XLSX.utils.table_to_sheet(state.instance, config)

    console.log('ws',ws)
    Object.keys(ws).filter((key1) => {
        if (typeof ws[key1] === 'object') {
            return true
        }
    }).forEach((key) => {
        if (props.dataFormat) {
            //숫자형은 cell type 숫자형으로 수정
            /**
                b	: Boolean
                e	: Error
                n	: Number
                d	: Date
                s	: Text
                z	: Stub
            */
            if (ws[key]?.v && typeof ws[key] === 'object') {
                let type = 's'

                if (!isNaN(Number(ws[key]['v']))) {
                    ws[key]['v'] = Number(ws[key]['v']); // 명시적으로 숫자로 변환
                    type = 'n'; // 타입 설정
                    if (Number.isInteger(ws[key]['v'])) {
                        ws[key]['z'] = '#,##0'; // 정수 형식 설정
                    } else {
                        ws[key]['z'] = '#,##0'; // 소수인 경우 일반 형식
                    }
                    ws[key]['t'] = type
                } else if (ws[key]['v'].substring(ws[key]['v'].length - 1) === '%') {
                    const cellData = ws[key]['v'].substring(0, ws[key]['v'].length - 1).replaceAll('-', '')
                    if (common.checkNumber(cellData) || common.checkFloat(cellData)) {
                        //문자열중에 퍼센트(%) 포멧팅인 경우 type 숫자
                        type = 'n'
                        if (props.dataFormat) ws[key]['z'] = "0.0%"
                        ws[key]['v'] = (Number(ws[key]['v'].substring(0, ws[key]['v'].length - 1)) / 100).toFixed(4)
                    }
                    ws[key]['t'] = type
                } else if (common.checkDateForm(ws[key]['v'])) {
                    //날짜형식 시분초 제외하고 표출

                    if (props.dataFormat) ws[key]['z'] = "yyyy-mm-dd"
                    // 날짜 문자열을 Date 객체로 변환
                    const dateValue = new Date(ws[key]['v']);

                    // xlsx 라이브러리에 맞게 날짜를 Excel 날짜 형식으로 변환
                    ws[key]['v'] = XLSX.SSF.format("yyyy-mm-dd", dateValue);
                    ws[key]['t'] = 'd'; // 데이터 타입을 날짜로 설정
                }

            }
        } else {
            ws[key]['t'] = 's'
        }

    })

    return ws
    // let wb = XLSX.utils.book_new()
    // XLSX.utils.book_append_sheet(wb,ws,fileName.replace('Yearly Cashflow FCST_',''))
    // autofitColumns(ws)
    // XLSX.writeFile(wb,fileName+'.XLSX')

}

const headerDateInsert = (ws, subject) => {
    const range1 = XLSX.utils.decode_range(ws['!ref']);
    
    // 마지막 행 복사 (현재 데이터의 최종 행을 저장해 둠)
    const lastRowData = [];
    for (let C = range1.s.c; C <= range1.e.c; ++C) {
        const cellAddress = { c: C, r: range1.e.r };
        const cell = XLSX.utils.encode_cell(cellAddress);
        if (ws[cell]) {
            lastRowData.push({ cell, value: ws[cell] });
        }
    }

    // 한 줄씩 밑으로 내리기 (복사된 행의 삭제 방지를 위해 마지막부터 처리)
    for (let R = range1.e.r; R >= 0; --R) {
        for (let C = range1.s.c; C <= range1.e.c; ++C) {
            const cellAddress = { c: C, r: R };
            const cellAddressNew = { c: C, r: R + 1 };
            const cell = XLSX.utils.encode_cell(cellAddress);
            const cellNew = XLSX.utils.encode_cell(cellAddressNew);
            if (ws[cell]) {
                ws[cellNew] = ws[cell];  // 데이터를 한 줄 밑으로 이동
                delete ws[cell];         // 기존 셀 데이터 삭제
            }
        }
    }

    // 복사한 마지막 행을 기존의 마지막 행 밑에 삽입
    for (const { cell, value } of lastRowData) {
        const decoded = XLSX.utils.decode_cell(cell);
        decoded.r += 1; // 복사된 마지막 행을 한 줄 밑에 삽입
        const newCell = XLSX.utils.encode_cell(decoded);
        ws[newCell] = value;
    }

    // A1에 값 넣기
    ws['A1'] = { t: 's', v: subject };
    
    // 참조 범위 업데이트
    ws['!ref'] = XLSX.utils.encode_range({
        s: range1.s,
        e: { c: range1.e.c, r: range1.e.r + 1 }
    });
}

const grayBackGround = (ws) => {
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddressA = XLSX.utils.encode_cell({ r: R, c: 0 }); // A열의 셀 주소 
            const cellAddressB = XLSX.utils.encode_cell({ r: R, c: 1 }); // b열의 셀 주소
            if (!ws[cellAddressA]?.v && ws[cellAddressB]?.v) { // A열 값이 비어있고 B열에 값이 있으면 
                for (let C = range.s.c; C <= range.e.c; ++C) { 
                    const cellAddress = XLSX.utils.encode_cell({ r: R, c: C }); 
                    if (ws[cellAddress]) { // 데이터가 있는 셀만 처리 
                        ws[cellAddress].s = ws[cellAddress].s || {}; 
                        ws[cellAddress].s.fill = { fgColor: { rgb: "C0C0C0" } // 회색 
                        }; 
                    } 
                } 
            }
        }
    }
}


function getEndingDigit(inputString) {
    const regex = /\d+$/;

    if (regex.test(inputString)) {
        const match = inputString.match(regex);
        return match[0].replace(/\D/g, '');
    }

    return null;
}

function autofitColumns(worksheet) {
    let objectMaxLength = [];

    const [startLetter, endLetter] = worksheet['!ref']?.replace(/\d/, '').split(':')
    const ranges = []

    let startIdx = startLetter.charCodeAt(0)
    let endIdx = 0;

    const regex = /^[A-Z]$/;
    [...endLetter].forEach((char, index) => {
        if (regex.test(char)) {
            endIdx = char.charCodeAt(0) + (index * 26)
        }
    })

    for (let i = startIdx; i < (endIdx + 1); i++) {
        ranges.push(i)
    }

    ranges.forEach((c) => {
        const cellHeader = String.fromCharCode(c)

        let maxCellLengthForWholeColumn = Array.from(
            { length: getEndingDigit(worksheet['!ref']) },
            (_, i) => i
        ).reduce((acc, i) => {
            const cell = worksheet[`${cellHeader}${i + 1}`]

            // empty cell
            if (!cell) return acc
            const charLength = typeof cell.v === 'number' ? cell.v.toString().length + 3 : cell.v.length + 7

            return acc > charLength ? acc : charLength
        }, 0)
        if (maxCellLengthForWholeColumn === 0) maxCellLengthForWholeColumn = 10
        objectMaxLength.push({ wch: maxCellLengthForWholeColumn })
    })
    worksheet['!cols'] = objectMaxLength
}


defineExpose({
    state,
    selectUploadFile,
    readFile,
    excelDownload,
    resetUploadFile,
    excelSheet2,
    excelSheet3
})
</script>